import { useRef } from 'react'
import { useOnScreen } from './useOnScreen'

export const useRefOnScreen = (rootMargin, threshold) => {
  const toBeIntersectedImgRef = useRef(null)
  const isVisible = useOnScreen(toBeIntersectedImgRef, rootMargin, threshold)

  return [toBeIntersectedImgRef, isVisible]
}
